/* gobal angular */
/**
 * Created by guntherclaes on 03/03/2017.
 */
var module = angular.module('header', []);
module.directive('vskoHeader', require('./directive/header/header'));
